<template>
  <Overlay class="change-dialog" v-on="$listeners">
    <div class="change-dialog_holder">
      <h1 class="heading1">{{ $t('Смена игры') }}</h1>
      <p class="change-dialog_description">{{ $t('Выбери игру, для которой будешь получать бонусы') }}</p>
      <div class="game-list">
        <div
          class="game-list_item"
          v-for="(title, game) in gamesList"
          :key="game"
          :class="['game-list_item__' + game, selectedGame === game && 'current']"
          v-text="title.name"
          @click="selectedGame = game"
        />
      </div>
      <Button class="change-dialog_button" variant="outlined" @click="close">
        {{ $t('Отменить') }}
      </Button>
      <Button variant="contained" :disabled="currentGame === selectedGame" :waiting="loading" @click="onChangeCardGame">
        {{ $t('Да, изменить') }}
      </Button>
      <button class="change-dialog_close" @click="close">{{ $t('Close') }}</button>
      <div class="change-dialog_error-wrapper">
        <div
          v-bind:class="['change-dialog_error', {'change-dialog_error__hidden': !this.changeGameError}]"
        >{{$t('Возникла ошибка. Повторите попытку.')}}</div>
      </div>
    </div>
  </Overlay>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'
import pick from 'lodash/pick'
import { namespace } from 'vuex-class'
import { gameTitles, availableGames } from '@/constants'
import Button from '@/common/components/Button'
import Overlay from '@/common/components/Overlay'
import { ValidationError } from '@/common/api/errors'

const cards = namespace('cards')

const checkValidationError = error => {
  const properInstance = error instanceof ValidationError
  const [{ code }] = error.errors

  return properInstance && code
}

@Component({
  components: { Overlay, Button }
})
class BindingChangeDialog extends Vue {
  @Prop(({ type: String, required: true })) currentGame
  @Prop(({ type: String, required: true })) cardCode

  @cards.Action changeCardGame
  @cards.State loading

  selectedGame = ''
  changeGameError = ''
  gamesList = pick(gameTitles, availableGames)

  created () {
    this.selectedGame = this.currentGame
  }

  async onChangeCardGame () {
    try {
      await this.changeCardGame({ game: this.selectedGame, cardCode: this.cardCode })
      this.$analytics.trackChangeCardGame({ screenId: this.$route.name, game: this.selectedGame })
      this.changeGameError = ''
      this.close()
    } catch (error) {
      const validationError = checkValidationError(error)

      if (validationError) {
        this.changeGameError = validationError
      } else {
        this.changeGameError = ''
        throw error
      }
    }
  }

  close () {
    this.loading || this.$emit('close')
  }
}

export default BindingChangeDialog
</script>

<style lang="scss" src="./styles/change-dialog.scss"/>
<style lang="scss" src="./styles/game-list.scss"/>
